import { Component, Input } from '@angular/core'
import { CartItemListComponent } from '@spartacus/cart/base/components'

@Component({
    selector: 'app-dispenser-order-items-list',
    templateUrl: './dispenser-order-items-list.component.html',
    styleUrls: ['./dispenser-order-items-list.component.scss'],
    standalone: false
})
export class DispenserOrderItemsListComponent extends CartItemListComponent {
  @Input() entries
}
